export const theme = {
  closeButtonBoxShadow: 'none',
  modalContentBackground: Styles.color.white,
  modalWrapperBackground: Styles.color.white,
};
